import { SECONDARY_NAV_NEXT_CLICK, SECONDARY_NAV_PREVIOUS_CLICK } from '../constants';

export interface SecondaryNavNextAction {
    type: 'SECONDARY_NAV_NEXT_CLICK';
}

export interface SecondaryNavPreviousAction {
    type: 'SECONDARY_NAV_PREVIOUS_CLICK';
}

export type SecondaryNavActions = SecondaryNavPreviousAction & SecondaryNavNextAction;
export type SecondaryNavClick = () => void;
export const secondaryNavNextClick = () => {
    return function (dispatch: Function, getState: Function) {
        const { navReducer, deltaReducer} = getState();
        const navId = navReducer.navId;
        const deltaId = deltaReducer.activePanel;

        dispatch({
            type: SECONDARY_NAV_NEXT_CLICK,
            payload: {
                navId,
                deltaId
            }
        });
    };
};

export const secondaryNavPreviousClick = () => {
    return function (dispatch: Function, getState: Function) {
        const { navReducer, deltaReducer} = getState();
        const navId = navReducer.navId;
        const deltaId = deltaReducer.activePanel;

        dispatch({
            type: SECONDARY_NAV_PREVIOUS_CLICK,
            payload: {
                navId,
                deltaId
            }
        });
    };
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/action/secondaryNavActions.ts